export default {
    getCategoriesFromInMem(state) {
        return state.categories;
    },
    getSelectedTreeComponent(state) {
        return state.treeSelectedItem
    },
    getSelectedCategoryInCategoryBrowse(state) {
        return state.selectedCategoryIdInBrowse;
    },
    getRootCategoryDetails(state){
        return state.rootCategoryDetails;
    },
};